import { MsalProvider } from '@azure/msal-react';
import { queryClient } from '@gen2/config/queryClient';
import { Microsoft } from '@gen2/services/social-login/microsoft/microsoft';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/app';
import CustomErrorBoundary from './app/components/CustomErrorBoundary/CustomErrorBoundary';
import { CustomRouter } from './app/components/router/CustomRouter';
import history from './app/components/router/history';
import { AuthProvider } from './contexts/AuthContext';
import './config/sentry';
import './i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const clientId = process.env['NX_PUBLIC_GOOGLE_CLIENT_ID'] ?? '';

root.render(
  (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <CustomRouter history={history}>
          <GoogleOAuthProvider clientId={clientId}>
            <MsalProvider
              instance={Microsoft.initialize(
                process.env['NX_PUBLIC_MICROSOFT_CLIENT_ID'],
              )}
            >
              <CustomErrorBoundary>
                <AuthProvider>
                  <App />
                </AuthProvider>
              </CustomErrorBoundary>
            </MsalProvider>
          </GoogleOAuthProvider>
        </CustomRouter>
      </QueryClientProvider>
    </StrictMode>
  ) as any,
);
